module.exports = __webpack_public_path__ + "f062e8ea404d7327e05b4b8b79d7e293.png";


//////////////////
// WEBPACK FOOTER
// ./markup/img/tutorial-video-bg-bottom.png
// module id = 1076
// module chunks = 0